export function mulberry32(a) {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    var t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export const DIRECT_KERNEL_VERSION = "betty-direct-market-v1";
export function directDrawFactor(drawFactor) {
  return 1 - 0.5 * (1 - Number(drawFactor));
}

export function simulateDirectMatch(lH, lA, r, rng, captureEvents = true) {
  if (![lH, lA, r].every(Number.isFinite) || lH < 0 || lA < 0 || r <= 0)
    throw new Error("Ungültige Direct-Simulationsgrundlage.");
  var pH = lH / 90,
    pA = lA / 90;
  const goalEvents = [];
  var gh = 0;
  var ga = 0;
  var ghHT = 0;
  var gaHT = 0;
  var firstGoalSide = null;
  var firstGoalMinute = null;

  var homeTrailed = false;
  var awayTrailed = false;
  var homeLedAfterTrailing = false;
  var awayLedAfterTrailing = false;

  for (var m = 0; m < 90; m++) {
    var factor = gh === ga ? r : 1 / r;

    var pMinuteH = pH * factor;
    var pMinuteA = pA * factor;

    if (pMinuteH > 1) pMinuteH = 1;
    if (pMinuteA > 1) pMinuteA = 1;
    if (pMinuteH < 0) pMinuteH = 0;
    if (pMinuteA < 0) pMinuteA = 0;

    if (rng() < pMinuteH) {
      gh++;
      if (captureEvents)
        goalEvents.push({
          minute: m + 1,
          side: "home",
          home: gh,
          away: ga,
          score: gh + ":" + ga,
        });
      if (firstGoalSide === null) {
        firstGoalSide = "home";
        firstGoalMinute = m + 1;
      }
    }

    if (rng() < pMinuteA) {
      ga++;
      if (captureEvents)
        goalEvents.push({
          minute: m + 1,
          side: "away",
          home: gh,
          away: ga,
          score: gh + ":" + ga,
        });
      if (firstGoalSide === null) {
        firstGoalSide = "away";
        firstGoalMinute = m + 1;
      }
    }

    if (gh < ga) homeTrailed = true;
    if (ga < gh) awayTrailed = true;

    if (homeTrailed && gh > ga) homeLedAfterTrailing = true;
    if (awayTrailed && ga > gh) awayLedAfterTrailing = true;

    if (m === 44) {
      ghHT = gh;
      gaHT = ga;
    }
  }

  return {
    home: gh,
    away: ga,
    ht: { home: ghHT, away: gaHT },
    goalEvents,
    firstGoalSide,
    firstGoalMinute,
    homeTrailed,
    awayTrailed,
    homeLedAfterTrailing,
    awayLedAfterTrailing,
  };
}
